import type { MabarParticipant } from '@/services/communityService';
import type { PadelRoundDetail } from '@/services/padelService';
import PadelRoundCard from './PadelRoundCard';
import { roundGames } from './padelListUtils';

interface PadelSessionRoundListProps {
  rounds: PadelRoundDetail[];
  canEdit: boolean;
  hideLineupEdit: boolean;
  participants: MabarParticipant[];
  isSparring: boolean;
  teamAName: string;
  teamBName: string;
  onChanged: () => void;
  onNotify: (message: string, type: 'success' | 'error') => void;
}

export default function PadelSessionRoundList({
  rounds,
  canEdit,
  hideLineupEdit,
  participants,
  isSparring,
  teamAName,
  teamBName,
  onChanged,
  onNotify,
}: PadelSessionRoundListProps) {
  return (
    <>
      {rounds.flatMap((round) => {
        const games = roundGames(round);
        const items = games.length > 0 ? games.map((game) => ({ ...round, game })) : [round];
        return items.map((item, index) => (
          <PadelRoundCard
            key={item.game?.slug ?? `round-${round.roundNumber}-${index}`}
            round={item}
            canEdit={canEdit}
            hideLineupEdit={hideLineupEdit}
            participants={participants}
            isSparring={isSparring}
            teamAName={teamAName}
            teamBName={teamBName}
            onChanged={onChanged}
            onNotify={onNotify}
          />
        ));
      })}
    </>
  );
}
